export {
    registerOnlineStatusHelper
};

function isGuid(value) {
    try {
      const regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return regexGuid.test(value);
    } catch(err){
      console.error(err);
    }
    return false;
}
  
function findObjectWithGuid(map) {
    try{
      for (const obj of map.values()) {
          if (obj && obj.source && obj.source.state && obj.source.state.identity && isGuid(obj.source.state.identity)) {
              return obj;
          }
      }
    } catch(err){
      console.error(err);
    }
    return null; // Return null if no matching object is found
}

function registerOnlineStatusHelper(){
    try {
        Handlebars.registerHelper("onlineStatusHelper", function(task, chat, options) {
          try{
            if (chat && chat.conversation && chat.conversation.participants){
              var customerParticipant = findObjectWithGuid(chat.conversation.participants)
              if (customerParticipant){
                if (customerParticipant.online) {
                  return options.fn(this);
                }
              }
            }
            return options.inverse(this);
      
            //This below can be uncommented once conversationHelper is fixed to reliably show online status.
            /*let conversationState = StateHelper.getConversationStateForTask(task);
            let conversationHelper = new ConversationHelper(conversationState);
            console.log(conversationHelper.isCustomerOnline);
            if (conversationHelper.isCustomerOnline) {
              return options.fn(this);
            } else {
              return options.inverse(this);
            }*/
          } catch(error) {
            console.log(error)
          }
          return options.fn(this);
        });
      } catch(err) {
        console.error("Handlebars Helper Registration Error: ", err);
      }
}
  